import * as React from 'react';
import * as _ from 'lodash';
export default function () {
    return React.createElement('div', { 'className': 'row center-xs middle-xs  full-height c-white w-100' }, React.createElement('h1', {}, 'Please wait...'));
}